import "./../scss/index.scss";

const defaultPrimaryColor1 = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-primary-color-1");
const defaultPrimaryColor2 = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-primary-color-2");
const defaultPrimaryColor3 = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-primary-color-3");
const defaultPrimaryColor4 = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-primary-color-4");
const defaultPrimaryColor5 = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-primary-color-5");
const defaultSecondaryColor = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-secondary-color");
const defaultSecondaryTextColor = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-secondary-text-color");
const defaultSecondaryTextColorHeaderFooter = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-secondary-text-color-header-footer");
const defaultCustomLogin = getComputedStyle(
  document.documentElement
).getPropertyValue("--default-custom-login");

//Primary Color SASS Variable
export const default_primary_color_1 =
  defaultPrimaryColor1 != undefined && defaultPrimaryColor1 != null
    ? defaultPrimaryColor1
    : "";
export const default_primary_color_2 =
  defaultPrimaryColor2 != undefined && defaultPrimaryColor2 != null
    ? defaultPrimaryColor2
    : "";
export const default_primary_color_3 =
  defaultPrimaryColor3 != undefined && defaultPrimaryColor3 != null
    ? defaultPrimaryColor3
    : "";
export const default_primary_color_4 =
  defaultPrimaryColor4 != undefined && defaultPrimaryColor4 != null
    ? defaultPrimaryColor4
    : "";
export const default_primary_color_5 =
  defaultPrimaryColor5 != undefined && defaultPrimaryColor5 != null
    ? defaultPrimaryColor5
    : "";

//Secondary Color SASS Variable
export const default_secondary_color =
  defaultSecondaryColor != undefined && defaultSecondaryColor != null
    ? defaultSecondaryColor
    : "";
export const default_secondary_text_color =
  defaultSecondaryTextColor != undefined && defaultSecondaryTextColor != null
    ? defaultSecondaryTextColor
    : "";
export const default_secondary_text_color_Header_Footer =
  defaultSecondaryTextColorHeaderFooter != undefined &&
  defaultSecondaryTextColorHeaderFooter != null
    ? defaultSecondaryTextColorHeaderFooter
    : "";

// Custom Login Flag
export const default_custom_login =
  defaultCustomLogin != undefined && defaultCustomLogin != null
    ? defaultCustomLogin
    : "";
